import {
  fetchProfessionalsDownloadsProductsData,
  fetchFilterData,
  setAllProducts,
  ProfessionalsDownloadsProductsPageIndex,
} from 'src/modules/professionals/downloads/products';
import { wrapper } from 'src/store';

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const [data, _filterData] = await Promise.all([
    fetchProfessionalsDownloadsProductsData(),
    fetchFilterData(),
  ]);

  store.dispatch(setAllProducts(data.productsSearch, data.searchResultsCount));

  const filterData = {
    productCategories: _filterData.productCategories.map(({ slug, ...rest }) => ({
      value: slug,
      ...rest,
    })),
    locationTypes: _filterData.locationTypes.map(({ slug, ...rest }) => ({
      value: slug,
      ...rest,
    })),
  };

  return {
    props: {
      productsDownloadsPage: { filterData },
    },
  };
});

export default ProfessionalsDownloadsProductsPageIndex;
